import { json } from "@sveltejs/kit";
import { p as prisma } from "../../../../chunks/prisma.js";
import { s as secure } from "../../../../chunks/utils2.js";
const POST = async ({ cookies, locals: { user } }) => {
  if (user?.id) {
    try {
      await prisma.user.update({
        where: { id: user.id },
        data: { refreshToken: null }
      });
    } catch (e) {
      console.error("Failed to clear refresh token:", e);
    }
  }
  cookies.delete("token", { path: "/", secure });
  cookies.delete("refreshToken", { path: "/", secure });
  return json({ message: "Logged out successfully" });
};
export {
  POST
};
